import { Directive, ElementRef, HostBinding, Input } from '@angular/core'
import { ButtonStrokedColors, ButtonStrokedSizes } from '../../../models/button.interfaces'

@Directive({
    selector: '[appButtonStroked]'
})
export class ButtonStrokedDirective {
    @Input() color: ButtonStrokedColors = 'primary'
    @Input() size: ButtonStrokedSizes = 'small'
    @Input() hoverEffect: boolean = true

    @HostBinding('class.hoverEffect') get buttonHoverEffect(): boolean {
        return this.hoverEffect
    }

    @HostBinding('class') get buttonClass(): string {
        const link = this.el.nativeElement.localName === 'a' ? 'd-inline-flex' : ''
        return `app-button-stroked app-button-stroked-${this.color} app-button-stroked-${this.size} ${link}`
    }

    constructor(private el: ElementRef) {}
}
